// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__9X-L3","paramInput":"JobSimulator_paramInput__2u45K","input":"JobSimulator_input__1ADVV"};